import {isFunction, isArray} from "../../funcs";
import AppChannel from "../AppChannel";
import Api from "../../classes/api/Api";


export default class NotificationChannel extends AppChannel {

    add(item) {
        this.trigger("add", item);
    }

    readNoty(ids, callback) {
        if ( !isFunction(callback) ) {
            callback = function() {};
        }

        if ( !isArray(ids) ) {
            ids = [ids];
        }

        Api.request({
            root: "customlogic",
            entity: "notifications",
            method: "read",
            data: {
                ID_NOTIFICATIONS: ids
            }
        }, function() {
            this.trigger("readNotifications", ids);
            callback();
        }.bind(this));
    }

    readAllNoty(callback) {
        if ( !isFunction(callback) ) {
            callback = function() {};
        }

        Api.request({
            root: "customlogic",
            entity: "notifications",
            method: "readAll",
            data: {}
        }, function() {
            this.trigger("readAllNotifications");
            callback();
        }.bind(this));
    }

    closeNotyBy(filter) {
        this.trigger("closeNotyBy", filter);
    }
}